import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Avatar,
    Stack,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import { useCookies } from "react-cookie";
import { motion } from "framer-motion";
// import { apiList, invokeApi } from "../../services/apiServices";
// import { config } from "../../config/config";

// --- Default "All" category ---
const allCategory = {
    label: "All",
    icon: "https://www.anveshan.farm/cdn/shop/files/all_product_active.svg?v=1713435265",
};

// --- Mapping API category names to icons ---
const categoryIcons = {
    New: {
        icon: "https://www.anveshan.farm/cdn/shop/files/newly.svg?v=1714126432",
    },
    Breakfast: {
        icon: "https://www.anveshan.farm/cdn/shop/files/a2ghee.svg?v=1712905687",
    },
    Snacks: {
        icon: "https://www.anveshan.farm/cdn/shop/files/oils.svg?v=1712905647",
    },
    Festival: {
        icon: "https://www.anveshan.farm/cdn/shop/files/bestdeals.svg?v=1712905646",
    },
    Superfoods: {
        icon: "https://www.anveshan.farm/cdn/shop/files/superfood.svg?v=1712905646",
    },
    Combo: {
        icon: "https://www.anveshan.farm/cdn/shop/files/combo.svg?v=1714126705",
    },
    "Ajji's Specials": {
        icon: "https://www.anveshan.farm/cdn/shop/files/under-999.svg?v=1726215410",
    },
};

// --- Default icon if API category not in mapping ---
const defaultIcon =
    "https://www.anveshan.farm/cdn/shop/files/all_product_active.svg?v=1713435265";

const CategoryMenu = ({ onSelectCategory }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [cookies] = useCookies();
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState("All");

    useEffect(() => {
        const fetchCategories = async () => {
            //   try {
            //     const response = await invokeApi(
            //       config.getMyCollege + apiList.getAllCategory,
            //       {},
            //       cookies
            //     );

            //     if (response?.status === 200) {
            //       const apiCategories = response.data.categories || [];
            //       setCategories(apiCategories);

            //       // Default active = All
            //       setActiveCategory("All");
            //       onSelectCategory("All");
            //     }
            //   } catch (err) {
            //     console.error("Failed to fetch categories", err);
            //   }
        };

        fetchCategories();
    }, []);

    const handleSelect = (label) => {
        setActiveCategory(label);
        onSelectCategory(label);
    };

    // Animation variants to match Courses component
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <Box
            sx={{
                bgcolor: "#fff",
                py: 3,
                overflowX: isMobile ? "auto" : "hidden",
                borderBottom: "2px solid #f5f5f5",
            }}
        >
            <Box
                sx={{
                    width: "fit-content",
                    mx: "auto",
                    px: isMobile ? 2 : 0,
                }}
            >
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                >
                    <Stack direction="row" spacing={3}>
                        {/* --- All Option --- */}
                        <motion.div variants={itemVariants}>
                            <Box
                                role="button"
                                tabIndex={0}
                                onClick={() => handleSelect("All")}
                                sx={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                    color: activeCategory === "All" ? "#6d1675" : "#666",
                                    transition: "all 0.3s ease",
                                    "&:hover": { 
                                        transform: "scale(1.05)", 
                                        color: "#6d1675" 
                                    },
                                }}
                            >
                                <Avatar
                                    src={allCategory.icon}
                                    alt="All"
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        bgcolor: activeCategory === "All" ? "#ffc20f" : "#f8f8f8",
                                        margin: "0 auto",
                                        border: activeCategory === "All" ? "3px solid #6d1675" : "2px solid #e0e0e0",
                                        boxShadow: activeCategory === "All" ? "0 4px 12px rgba(109, 22, 117, 0.3)" : "0 2px 8px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            boxShadow: "0 6px 16px rgba(109, 22, 117, 0.4)",
                                        }
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        mt: 1,
                                        color: activeCategory === "All" ? "#6d1675" : "#333",
                                        fontFamily: "inherit",
                                    }}
                                >
                                    All
                                </Typography>
                                {activeCategory === "All" && (
                                    <Box 
                                        sx={{ 
                                            height: 3, 
                                            bgcolor: "#ffc20f", 
                                            width: "40px", 
                                            mx: "auto",
                                            mt: 0.5,
                                            borderRadius: 2
                                        }} 
                                    />
                                )}
                            </Box>
                        </motion.div>

                        {/* --- API Categories --- */}
                        {categories.map((item) => {
                            const isActive = activeCategory === item.category;
                            const icon = categoryIcons[item.category]?.icon || defaultIcon;

                            return (
                                <motion.div key={item.id} variants={itemVariants}>
                                    <Box
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => handleSelect(item.category)}
                                        sx={{
                                            textAlign: "center",
                                            cursor: "pointer",
                                            color: isActive ? "#6d1675" : "#666",
                                            transition: "all 0.3s ease",
                                            "&:hover": { 
                                                transform: "scale(1.05)", 
                                                color: "#6d1675" 
                                            },
                                        }}
                                    >
                                        <Avatar
                                            src={icon}
                                            alt={item.category}
                                            sx={{
                                                width: 60,
                                                height: 60,
                                                bgcolor: isActive ? "#ffc20f" : "#f8f8f8",
                                                margin: "0 auto",
                                                border: isActive ? "3px solid #6d1675" : "2px solid #e0e0e0",
                                                boxShadow: isActive ? "0 4px 12px rgba(109, 22, 117, 0.3)" : "0 2px 8px rgba(0,0,0,0.1)",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    boxShadow: "0 6px 16px rgba(109, 22, 117, 0.4)",
                                                }
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                mt: 1,
                                                color: isActive ? "#6d1675" : "#333",
                                                fontFamily: "inherit",
                                            }}
                                        >
                                            {item.category}
                                        </Typography>
                                        {isActive && (
                                            <Box 
                                                sx={{ 
                                                    height: 3, 
                                                    bgcolor: "#ffc20f", 
                                                    width: "40px", 
                                                    mx: "auto",
                                                    mt: 0.5,
                                                    borderRadius: 2
                                                }} 
                                            />
                                        )}
                                    </Box>
                                </motion.div>
                            );
                        })}
                    </Stack>
                </motion.div>
            </Box>
        </Box>
    );
};

export default CategoryMenu;